module.exports = __webpack_public_path__ + "img/bigmat-login.053daf5f.jpg";